import { AppParameters } from '@app/infrastructure/parameters/model/AppParameters';
import { Tenant } from '@app/infrastructure/tenant/model/Tenant';
import { createContext } from 'react';

export const AppParametersContext = createContext<AppParameters>({
    tenant: Tenant.LT,
    supportedLocales: [],
    compensaPdfUrl: '',
    publicFolderPrefix: '',
    healthInsuranceBusiness: '',
    auth: {
        sebAuthUrl: '',
        luminorAuthUrl: '',
    },
    eshopInfoUrls: {
        mtpl: '',
        casco: '',
        mtplCasco: '',
        privacyPolicy: '',
        privacyPolicyEn: '',
        mtplTerms: '',
        cascoTerms: '',
        mtplRoadAssistanceBasic: '',
        mtplRoadAssistancePremium: '',
        techAssistance: '',
        cascoAdditionalCoverage: '',
        greenCourseInfo: '',
        homeInsurance: '',
        accidentsInsurance: '',
        travelInsurance: '',
        transportInsurance: '',
        comparePolicies: '',
        blueEmiLink: '',
        alarmLevelInfo: '',
    },
    eshopFooterUrls: {
        insuranceRules: '',
        privacyPolicy: '',
        privacyPolicyEn: '',
        cookiesPolicy: '',
        accessibility: '',
        contacts: '',
        facebook: '',
        instagram: '',
        linkedin: '',
    },
    eshopLifeInfoUrls: {
        allTerms: '',
        compensaNumber: '',
        fixedPaymentConditions: '',
        increasingPaymentConditions: '',
        bookConsultationLUrl: '',
        compensaEENumber: '',
        compensaEmail: '',
    },
    eshopTravelInfoUrls: {
        territoryVerification: '',
        readMoreInfo: '',
        age75InfoLt: '',
        age75InfoEn: '',
        age70InfoLt: '',
        age70InfoEn: '',
        travelInsuranceRules: '',
    },
    eshopPersonalAccidentsInfoUrls: {
        readMoreInfo: '',
        paInsuranceRules: '',
        selectedInsurance: '',
        compareLt: '',
        compareEn: '',
    },
    eshopHomeInsuranceInfoUrls: {
        readMoreInfo: '',
        contactUs: '',
        contactUsEn: '',
        compareUrlLt: '',
        compareUrlEn: '',
        homeRulesLt: '',
        homeRulesEn: '',
    },
    smartId: {
        waitDuration: 0,
        checkInterval: 0,
    },
    mobileId: {
        waitDuration: 0,
        checkInterval: 0,
    },
    twoFactor: {
        codeDuration: 0,
    },
    hereMaps: {
        apiKey: '',
        endpoints: {
            autocomplete: '',
            mapCore: '',
            mapService: '',
            mapUi: '',
            mapEvents: '',
        },
    },
    settings: {
        general: {
            accessibilityMenu: false,
            testInt: 0,
            testBool: false,
            testSetting: '',
            swedbankAuth: false,
            esalesEstonianLifeInsurancePage: false,
            esalesTransportPage: false,
            esalesLifeOrientationalPrice: 0,
            esalesTransportGtmId: '',
            esalesLifeGtmId: '',
            sebAuth: false,
            tenant: '',
            eeEshopDefaultCountryCode: '',
            esalesTravelPage: false,
            esalesTravelGtmId: '',
            esalesTransportLivechatEnabled: false,
            esalesTravelLivechatEnabled: false,
            esalesPaPage: false,
            esalesPaGtmId: '',
            esalesTransportBankAuth: false,
            esalesTransportAuth: false,
            esalesHomeInsurancePage: false,
            esalesHomeInsuranceGtmId: '',
            esalesTravelAuthEnabled: false,
            luminorAuth: false,
            twoFactorAuth: false,
            selfServicePortalEnabled: true,
            lifeEshopCookiebotEnabled: false,
            esalesHomeAvailableEsalesRisks: [],
            esalesPaLivechatEnabled: false,
            esalesHomeLivechatEnabled: false,
            selfServiceLivechatEnabled: false,
            dailyClaimLimitEnabled: false,
            hideNonPecuniaryDamagesStep: true,
            hideLimitsColumnSeesaam: true,
        },
    },
    travelClaimBanks: [],
    cnlClaimsUrls: {
        websiteUrl: '',
        dpoEmail: '',
        infoEmail: '',
        reportMtplLiabilityAccident: '',
    },
});
